import { render, staticRenderFns } from "./PanelCompetitionLanguages.vue?vue&type=template&id=27ae2c76&scoped=true&"
import script from "./PanelCompetitionLanguages.vue?vue&type=script&lang=js&"
export * from "./PanelCompetitionLanguages.vue?vue&type=script&lang=js&"
import style0 from "./PanelCompetitionLanguages.vue?vue&type=style&index=0&id=27ae2c76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ae2c76",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27ae2c76')) {
      api.createRecord('27ae2c76', component.options)
    } else {
      api.reload('27ae2c76', component.options)
    }
    module.hot.accept("./PanelCompetitionLanguages.vue?vue&type=template&id=27ae2c76&scoped=true&", function () {
      api.rerender('27ae2c76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PanelCompetitionLanguages.vue"
export default component.exports